import React, { useEffect, useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import CountriesData from "./countries-coordinates.json";
import clsx from "clsx";
import { formatNumber } from "src/utils/helper/functions";

const geoUrl = "/features.json";

type MapChartProps = {
  assetsAllocationData: any;
};

const MapChart: React.FC<MapChartProps> = ({
  assetsAllocationData,
}: MapChartProps) => {
  const [markers, setMarkers] = useState<any[]>([]);

  useEffect(() => {
    setMarkers(
      assetsAllocationData
        ?.filter((ele: any) => ele?.value > 0)
        .map((data: any) => {
          return {
            name: data?.label,
            coordinates: CountriesData.find(
              (country) => country.label === data?.label
            )?.coordinates,
            info: data?.value,
          };
        })
    );
  }, [assetsAllocationData]);

  return (
    <div className="relative">
      <ComposableMap
        data-tip=""
        projectionConfig={{ scale: 250 }}
        style={{
          width: "700px",
          height: "300px",
        }}
      >
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                style={{
                  default: {
                    fill: "#D6D6DA",
                    outline: "none",
                  },
                  hover: {
                    fill: "#002F6C",
                    outline: "none",
                  },
                  pressed: {
                    fill: "#E42",
                    outline: "none",
                  },
                }}
              />
            ))
          }
        </Geographies>
        {markers.map(({ name, coordinates, info }: any) => (
          <Marker key={name} coordinates={coordinates || [0, 0]}>
            <circle r={10} fill="#002F6C" stroke="#fff" strokeWidth={2} />
          </Marker>
        ))}
      </ComposableMap>
      <div
        className={clsx(
          "absolute start-4 -bottom-0 z-10 flex flex-col gap-1"
        )}
      >
        {assetsAllocationData
          ?.filter((ele: any) => ele?.value > 0)
          ?.sort((a: any, b: any) => b.value - a.value)
          .map((data: any) => (
            <div key={data.label} className="flex flex-row items-center gap-1">
              <span className="w-1 h-1 rounded-full bg-blue-500"></span>
              <p className="text-xs text-[#2a2a2a] font-medium w-14">
                {formatNumber(+data?.value, 2)} %{" "}
              </p>
              <div className="text-[#2a2a2a] rounded-full text-xs font-medium">
                - {data?.label}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MapChart;
